import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';
import SimpleClass from '../classes/SimpleClass';

Swiper.use([Pagination, Navigation, Autoplay]);

export default class Carousel extends SimpleClass {
  constructor(
    element,
    elLength,
    parentClassSelector,
    options = {},
    args = {
      debug: false,
    }
  ) {
    super();

    this.debug = args.debug || false;
    this.options = { ...options };

    this.classes = {
      ACTIVE_PAGINATION_TITLE: 'link',
      CAROUSEL_LOOP: 'carousel-loop',
    };

    // state
    this.state = {
      init: false,
      destroyed: false,
    };


    // dom selectors
    this.dom = {
      container: element,
      wrapper: element.querySelector('.swiper-wrapper'),
      slides: element.querySelectorAll('.swiper-slide'),
      pagination: element.querySelector('.swiper-pagination'),
      paginationTitles: element.querySelector('.swiper-pagination-titles'),
      paginationTitlesSingle: [],
      nav: element.querySelector('.nav-arrows'),
      youtube: element.querySelector('.swiper-youtube'),
      youtubeAll: element.querySelectorAll('.swiper-youtube'),
      vimeo: element.querySelector('.swiper-vimeo'),
      vimeoAll: element.querySelectorAll('.swiper-vimeo'),
    };

    if (this.dom.container.classList.contains('add-pagination') && typeof this.options.pagination !== 'undefined') {
      delete this.options.pagination;
    }

    let video = false;
    if (this.dom.youtube || this.dom.vimeo) {
      video = true;
    }

    this.swiperOptions = {
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1025: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
      loop: this.dom.container.classList.contains(this.classes.CAROUSEL_LOOP),
      speed: 1200,
      pagination: {
        el: this.dom.pagination,
        type: this.dom.pagination?.dataset?.pagination || 'bullets',
        clickable: true,
      },
      autoplay:
        video === true
          ? false
          : {
              delay: 5000,
              disableOnInteraction: false,
            },
      scrollbar: {
        draggable: true,
      },
      ...this.options,
    };

    if (this.options.navigation) {
      let nav = null;

      if (this.dom.container.parentNode) {
        nav = this.dom.container.parentNode.querySelector('.swiper-navigation');
      }

      if (nav && this.dom.slides.length <= elLength) {
        nav.classList.add('hidden');
      }

      this.swiperOptions.navigation = {
        nextEl: `${parentClassSelector} .swiper-button-next`,
        prevEl: `${parentClassSelector} .swiper-button-prev`,
      };
    }

    const visibleElements =  element.dataset.showOnXxl || 0;
    const sliderElements = this.dom.slides.length;

    if (sliderElements <= visibleElements) {
      this.dom.container.closest('.m-carousel').classList.add('centered');
      this.swiperOptions.allowTouchMove = false;

    } else {
      this.dom.container.closest('.m-carousel').classList.remove('centered');
    }

    if (this.dom.slides && this.dom.slides.length < 2) {
      this.swiperOptions.pagination = false;
    }

    this.swiper = new Swiper(this.dom.container, this.swiperOptions);

    this.swiper.on('observerUpdate', () => {
      this.updateNav();
    });
    this.swiper.on('slideChange', () => {
      this.updateNav();
    });


    if (this.swiper.pagination && this.dom.pagination) {
      this.onSlideChange(this.swiper);
      this.swiper.on('paginationUpdate', (swiper) => {
        this.onSlideChange(swiper);
      });
    }

    if (this.dom.paginationTitles && this.dom.slides.length > 1) {
      const titleWrapper = document.createElement('div');
      const title = document.createElement('span');

      this.dom.slides.forEach((slide, loopIndex) => {
        const titleEl = title.cloneNode(true);
        const titleWrapperEl = titleWrapper.cloneNode(true);

        titleEl.textContent = slide.dataset.title || `Slide ${loopIndex}`;
        titleWrapperEl.dataset.index = loopIndex;
        titleWrapperEl.classList.add('swiper-pagination-title');

        // adds active class to the current element
        if (loopIndex === this.swiper.realIndex) {
          titleWrapperEl.classList.add(this.classes.ACTIVE_PAGINATION_TITLE);
        }
        titleWrapperEl.addEventListener('click', (e) => {
          e.stopPropagation();
          const { index } = e.currentTarget.dataset;
          this.swiper.slideTo(parseInt(index, 10));
        });

        titleWrapperEl.appendChild(titleEl);

        this.dom.paginationTitlesSingle.push(titleWrapperEl);
      });
      this.dom.paginationTitlesSingle.forEach((el) => this.dom.paginationTitles.appendChild(el));
      const changeActiveTitle = (index) => {
        this.dom.paginationTitlesSingle.forEach((el) => el.classList.remove(this.classes.ACTIVE_PAGINATION_TITLE));
        this.dom.paginationTitlesSingle[index].classList.add(this.classes.ACTIVE_PAGINATION_TITLE);
      };
      this.swiper.on('slideChange', (swiper) => changeActiveTitle(swiper.realIndex));
    }

    // event listeners
    this.initEventListeners();

    // init
    this.dom.container.classList.add('swiper-video');

    this.init();
  }

  updateNav() {
    if (this.dom.container.querySelector('.card-media')) {
      const imgHeight = this.dom.container.querySelector('.card-media img').height;
      const arrPosition = Math.ceil(imgHeight / 2 - 18);

      this.dom.container.querySelectorAll('.swiper-navigation button').forEach((item) => {
        const itemCopy = item;
        itemCopy.style.top = `${arrPosition}px`;
      });
    }
  }

  stopPlayingVideo(item) {
    if (this.dom.vimeo || this.dom.youtube) {
      const videos = [...document.querySelectorAll('iframe, video')];
      const mute = '&mute=1&muted=1';

      videos.forEach((video) => {
        if (video.tagName.toLowerCase() === 'video') {
          video.pause();
        } else {
          const { src } = video;
          const videoCopy = video;

          if (src.includes('&autoplay=1')) {
            const autoplayPosition = src.indexOf('&autoplay=1');
            videoCopy.src = `${src.slice(0, autoplayPosition)}${src.slice(autoplayPosition + 11)}`;
          } else {
            videoCopy.src = src;
          }
        }
      });

      setTimeout(() => {
        const videoSrc = item.src;
        item.setAttribute('src', `${videoSrc + mute}&autoplay=1`);
      });
    }
  }



  onSlideChange(swiper) {
    let start = swiper.realIndex;
    let end = 5;
    const iframe = swiper.slides[swiper.activeIndex].querySelector('iframe');

    if (swiper.realIndex < 3) {
      start = 0;
    } else {
      start = swiper.realIndex - 2;
    }

    if (iframe) {
      this.stopPlayingVideo(iframe);
    }

    if (swiper.realIndex)
      if (swiper.slides.length < start + 5) {
        end = swiper.slides.length;
      } else {
        end = start + 5;
      }

    if (swiper.slides.length < 5) {
      start = 0;
      end = 5;
    }

    const paginationBullets = this.dom.pagination.querySelectorAll('.swiper-pagination-bullet');

    paginationBullets.forEach((el) => {
      el.classList.remove('active', 'bullet-second-last', 'bullet-last');
    });

    for (let i = start; i < end; i += 1) {
      if (!paginationBullets[i]) return;

      paginationBullets[i].classList.add('active');

      if (i === end - 2) {
        paginationBullets[i].classList.add('bullet-second-last');
      }

      if (i === end - 1) {
        paginationBullets[i].classList.add('bullet-last');
      }

      if (swiper.realIndex > 1) {
        if (i === start) {
          paginationBullets[i].classList.add('bullet-last');
        }

        if (i === start + 1) {
          paginationBullets[i].classList.add('bullet-second-last');
        }
      }
    }
  }

  isCurrentSlideVideo() {
    // console.log(this.dom.container);
    // let video = false;
    // if (this.dom.youtube || this.dom.vimeo) {
    //     video = true;
    // }
    // console.log(video);
    // let videoSrc = video.src;
    // video.attr('src', videoSrc + '&autoplay=1')
  }

  setYoutubeImage() {
    document.querySelectorAll('[data-movie-id]').forEach(link => {
      const movieId = link.getAttribute('data-movie-id');

      // Sprawdzamy, czy obrazek już istnieje, aby nie tworzyć kilku
      if (movieId && !link.querySelector('img')) {
        const img = document.createElement('img');
        img.src = `https://img.youtube.com/vi/${movieId}/hqdefault.jpg`;
        img.alt = '';

        const textDiv = link.querySelector('.swiper-slide__text');
        if (textDiv) {
          link.insertBefore(img, textDiv);  // Wstawiamy img przed textDiv
        } else {
          link.appendChild(img);  // Jeśli div nie istnieje, dodajemy img na końcu
        }
      }
    });

  }

  init() {
    this.log('✨ Carousel init');
    this.isCurrentSlideVideo();
    this.setState('init', true);
    // this.setYoutubeImage();

    // TODO Stop sliders after entering a fullscreen mode
  }

  initEventListeners() {
    this.navArrowsListeners();

    if (this.dom.pagination) {
      this.dom.pagination.addEventListener('click', (e) => {
        this.stopPlayingVideo();
        e.stopPropagation();
      });
    }
  }

  navArrowsListeners() {
    if (!this.dom.nav) return;

    const next = this.dom.nav.querySelector('.arrow-next');
    const prev = this.dom.nav.querySelector('.arrow-prev');

    next.addEventListener('click', () => {
      this.swiper.slideNext();
    });
    prev.addEventListener('click', () => {
      this.swiper.slidePrev();
    });
  }

  handleClick(e) {
    const { innerWidth } = window;
    const { clientX } = e;

    if (clientX / innerWidth > 0.5) {
      this.swiper.slideNext();
      return;
    }
    this.swiper.slidePrev();
  }

  getSwiper() {
    return this.swiper;
  }
}
